import { v4 as uuid } from 'uuid';

export const imageUrl = (value) => {
  if (typeof value === 'string') return value;
  return value && typeof value.url === 'string' ? value.url : '';
};

const defaultsFrom = (fields = []) => fields.reduce((defaults, field) => ({
  ...defaults,
  ...(field.defaults || {}),
  [field.key]: field.default ?? field.defaultValue ?? '',
}), {});

export const createModule = (type, definition) => ({
  id: uuid(),
  type,
  data: defaultsFrom(definition?.fields),
  features: [],
});

export const createFeature = (type, definition) => ({
  id: uuid(),
  type,
  data: defaultsFrom(definition?.fields),
});

export const normalizeModules = (modules = []) => modules.map((module) => ({
  ...module,
  id: module.id || uuid(),
  data: module.data || {},
  features: (module.features || []).map((feature) => ({
    ...feature,
    id: feature.id || uuid(),
    data: feature.data || {},
  })),
}));
